const AVAILABILITY_TIME_PATTERN = /^(\d{1,2}):(\d{1,2})$/
const HALF_HOUR_MINUTES = new Set([0, 30])

export const isHalfHourAvailabilityMinute = (minute) =>
  Number.isInteger(minute) && HALF_HOUR_MINUTES.has(minute)

export const isHalfHourAvailabilityTime = ({ hour, minute }) =>
  Number.isInteger(hour) &&
  hour >= 0 &&
  hour <= 23 &&
  isHalfHourAvailabilityMinute(minute)

export const formatAvailabilityTime = (hour, minute = 0) => {
  if (!Number.isInteger(hour) || !Number.isInteger(minute)) {
    return ''
  }

  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
    return ''
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

export const parseAvailabilityTime = (timeValue) => {
  if (typeof timeValue !== 'string') {
    return null
  }

  const match = timeValue.match(AVAILABILITY_TIME_PATTERN)
  if (!match) {
    return null
  }

  const hour = Number(match[1])
  const minute = Number(match[2])
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
    return null
  }

  return {
    hour,
    minute,
    totalMinutes: hour * 60 + minute,
  }
}

export const normalizeAvailabilityTime = (timeValue) => {
  const parsed = parseAvailabilityTime(timeValue)
  if (!parsed) {
    return ''
  }

  return formatAvailabilityTime(parsed.hour, parsed.minute)
}

export const formatAvailabilityTimeFromDate = (dateValue) => {
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue)
  if (Number.isNaN(date.getTime())) {
    return ''
  }

  return formatAvailabilityTime(date.getHours(), date.getMinutes())
}

export const formatAvailabilityDisplayTime = (timeValue) => {
  const parsed = parseAvailabilityTime(timeValue)
  if (!parsed) {
    return ''
  }

  const displayHour =
    parsed.hour > 12 ? parsed.hour - 12 : parsed.hour === 0 ? 12 : parsed.hour
  const ampm = parsed.hour >= 12 ? 'PM' : 'AM'

  return `${displayHour}:${String(parsed.minute).padStart(2, '0')} ${ampm}`
}

export const getNextHalfHourAvailabilityTime = ({ hour, minute }) => {
  if (!isHalfHourAvailabilityTime({ hour, minute })) {
    return ''
  }

  const nextHour = minute === 30 ? hour + 1 : hour
  const nextMinute = minute === 30 ? 0 : 30
  return formatAvailabilityTime(nextHour, nextMinute)
}
